import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import DeactivatedSupplementMessage from '@components/DeactivatedSupplementMessage/DeactivatedSupplementMessage';
import RichContent from '@components/RichContent/RichContent';
import ViewProductPageButton from '@components/ViewProductPageButton/ViewProductPageButton';
import { IMedicationResponseDetails } from '@interfaces/medications';
import useSupplementCategoryById from '@store/hooks/useSupplementCategoryById';
import { getParsedText } from '@views/AdminInquiriesPage/AdminInquiryList/SupplementInquiryDetails/SupplementInformationForm/utils';

import SupplementResponseDetailsField from './SupplementResponseDetailsField/SupplementResponseDetailsField';

import './style.scss';

interface IProps {
  data: IMedicationResponseDetails;
}

const MedicationResponseDetails: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  const supplementCategory = useSupplementCategoryById(data?.medicationInquiryId);

  return (
    <div className="medication-response-details-body">
      <Typography variant="h3" className="medication-response-details-body__title">
        {data.name}
      </Typography>

      <ViewProductPageButton
        linkToProductPage={data.productLink}
        className="medication-response-details-body__link"
      />

      <SupplementResponseDetailsField label={t('inquiryResponse.comments')}>
        {data.comments ? (
          <RichContent className="medication-response-details-body__comments">
            {getParsedText(data.comments)}
          </RichContent>
        ) : (
          '-'
        )}
      </SupplementResponseDetailsField>
    </div>
  );
};

export default MedicationResponseDetails;
